import { render, staticRenderFns } from "./ContactListSw.vue?vue&type=template&id=7c42916a&scoped=true"
import script from "./ContactListSw.vue?vue&type=script&lang=js"
export * from "./ContactListSw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c42916a",
  null
  
)

export default component.exports